<template>
  <span>
    {{ title }}
    <button @click="hidecolumn(field)" class="k-button k-primary p-1 small">
      Hide
    </button>
  </span>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    field: String,
    title: String,
    sortable: [Boolean, Object]
  },
  setup(props, ctx) {
    const hidecolumn = e => {
      ctx.emit('hidecolumn', e)
    }

    return {
      hidecolumn
    }
  }
})
</script>

<style scoped></style>
